import dayjs from "dayjs";

// 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
export const PAY_WEEK_START_DAY = 5; // Friday

export function startOfPayWeek(date, startDay = PAY_WEEK_START_DAY) {
    const d = dayjs(date);
    const diff = (d.day() - startDay + 7) % 7;
    return d.subtract(diff, 'day').startOf('day');
}

export function endOfPayWeek(date, startDay = PAY_WEEK_START_DAY) {
    return startOfPayWeek(date, startDay).add(6, 'day').endOf('day');
}